<template>
	<div class="site-content">
		<section id="slider" class="intro-video">

			<agile class="agile_home-page" :options="slider.options" :autoplaySpeed="parseInt(slider.options.autoplaySpeed)" v-if="sliderList.length > 0">
				<div class="slide" v-for="slide in sliderList" :key="'agile-slide-1_'+slide.id" :style="'background-image: url('+encodeURI(slide.image)+')'">
					<div class="slide__content" >
					</div>
				</div>
			</agile>
			<div class="agile_home-page" v-if="sliderList.length === 0">
				<div class="slide  agile__slide"

					 :style="'background-image: url('+slider.placeholder.image+')'">
					<div class="slide__content"></div>
				</div>
			</div>

         <div class="intro-video__container" v-if="breakpoint.abs > 2">
            <router-link v-if="closestRace.found" :to="closestPath" class="intro-video__btn">
               {{t('home.intro.video-btn')}}
            </router-link>
         </div>

      </section><!-- /.intro-video -->


      <section id="program" class="section program">

         <div class="section__header section__header--next-race" v-if="breakpoint.abs < 3">
            <router-link v-if="closestRace.found" :to="closestPath" class="intro-video__btn mt-0 mb-0">
               {{t('home.intro.video-btn')}}
            </router-link>
         </div>

			<header class="section__header program__header">
				<h2 class="section__title program__header__title" v-html="t('home.program.header.title')"></h2>
			</header>

			<timeline-component :initialDate="today"></timeline-component>


			<footer class="program__footer">
				<div class="program__footer__container">
					<div class="timeline__legend">
						<span><span class="icon icon--chrono"></span> {{t('timeline.legend.soon')}} </span>
						<span><span class="icon icon--loop"></span> {{t('timeline.legend.running')}}</span>
						<span><span class="icon icon--flag"></span>{{t('timeline.legend.finish')}} </span>
						<span><span class="icon icon--close"></span> {{t('timeline.legend.close')}}</span>
						<span>{{t('timeline.legend.info')}}</span>
					</div>
				</div>
			</footer>
		</section>


		<section id="howto" class="section tuto" :class="{'pointer': !getUserStatus}" @click="goToRegister">
			<header class="section__header tuto__header">
				<h2 class="section__title tuto__header__title">Comment <b>jouer</b></h2>
			</header>
			<div class="section__content">

				<div class="tuto__container">
					<div class="tuto__steps">
						<div class="tuto__steps__item">
							<div class="tuto__steps__number">1</div>
							<img class="tuto__steps__picto" src="@/assets/img/picto/pen.svg" alt="Inscription">
							<h3 class="tuto__steps__title" v-html="t('home.tuto.1.title')"></h3>
							<p class="tuto__steps__text" v-html="t('home.tuto.1.text')"></p>
						</div>
						<div class="tuto__steps__item">
							<div class="tuto__steps__number">2</div>
							<img class="tuto__steps__picto" src="@/assets/img/picto/money.svg" alt="Dépôt">
							<h3 class="tuto__steps__title" v-html="t('home.tuto.2.title')"></h3>
							<p class="tuto__steps__text" v-html="t('home.tuto.2.text')"></p>
						</div>
						<div class="tuto__steps__item">
							<div class="tuto__steps__number">3</div>
							<img class="tuto__steps__picto" src="@/assets/img/picto/ticket.svg" alt="Jeu">
							<h3 class="tuto__steps__title" v-html="t('home.tuto.3.title')"></h3>
							<p class="tuto__steps__text" v-html="t('home.tuto.3.text')"></p>
						</div>
					</div>
				</div><!-- /.tuto__container -->

			</div><!-- /.section__content -->
		</section><!-- /.section.tuto -->

		<guide-component id="guide"></guide-component>

		<section class="section tiles threeImages">
			<div class="row">
				<div class="col-md-4 col-sm-4 col-xs-12">
					<banner :priority="1"></banner>
				</div>
				<div class="col-md-4 col-sm-4 col-xs-12">
					<banner :priority="2"></banner>
				</div>
				<div class="col-md-4 col-sm-4 col-xs-12">
					<banner :priority="3"></banner>
				</div>
			</div>
		</section><!-- .section.tiles -->

		<div class="home__floating-dots" :class="anchorsColor" v-if="breakpoint.abs > 2">
			<div class="floatRight">
				<div v-for="anc in anchors" class="home__floating-dots__item" :class="{ 'active': anc.active }" :key="anc.name" @click="anchorsClick(anc.id)">
					{{anc.name}}
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Vue from 'vue';
	import Vuex from 'vuex';
	import Timeline from '@/components/race/timeline/Timeline';
	import Guide from '@/components/parts/Guide';
	import VueAgile from 'vue-agile';
	import Banner from '@/components/parts/Banner';
	import moment from 'moment-timezone';

	Vue.use(VueAgile);

	export default {
		name: 'HomePage',
		components: {
			'timeline-component': Timeline,
			'guide-component': Guide,
			'banner': Banner
		},
		computed: {
			...Vuex.mapGetters([
				'closestRace',
				'getUserStatus'
			]),
			today() {
				return moment().format('YYYY-MM-DD');
			},

			closestPath() {

				return {
					name: 'Race',
					params: {
						'meeting_id': this.closestRace.meetingId,
						'race_id': this.closestRace.raceId
					}
				}
			},
			timing(){

				return this.$store.state.slides.timing;
			},
			sliderList(){

				return  this.$store.state.slides.slider.slice().sort((a, b)=> a.priority - b.priority);

			}
		},
		watch:{
			timing(val){
				this.slider.options.autoplaySpeed = parseInt(val);
			}
		},
		data(){
			return{
				slider: {
					options:{
						autoplay: true,
						autoplaySpeed: 5000,
						dots: false,
						arrows: false
					},
					placeholder: {
						"id":-1,
						"name":"Temp",
						"image": require('../img/banner.jpg'),
						"active":true,
						"priority": 99
					}
				},
				anchorsColor: '',
				anchors:[
					{
						id: 'slider',
						active: false,
						name: 'Accueil',
						color: 'white'
					},
					{
						id: 'program',
						active: false,
						name: 'Programme et résultats',
						color: 'black'
					},
					{
						id: 'howto',
						active: false,
						name: 'Comment Jouer',
						color: 'black'
					},
					{
						id: 'guide',
						active: false,
						name: 'Guide des paris',
						color: 'black'
					}
				]


			}
		},
		mounted(){
			//Initial calc
			this.calcAnchors();
			//Add scroll listener
			// eslint-disable-next-line
			$(window).scroll(this.calcAnchors);
			this.$store.dispatch('getHomePageSlider');
		},
		destroyed(){
			//Remove scroll listener
			// eslint-disable-next-line
			$(window).off("scroll", this.calcAnchors);
		},
		methods:{
			calcAnchors(){
				let headerH = document.querySelector('.site-header');

				if(headerH){
					headerH = headerH.getBoundingClientRect().height;
				}else{
					return;
				}

				for(let anc of this.anchors){
					let bound = document.getElementById(anc.id).getBoundingClientRect();

					anc.active = bound.top <= headerH && Math.abs( bound.top ) < bound.height - headerH; //Check if it in viewport
					if(anc.active){
						this.anchorsColor = anc.color;
					}

				}

			},
			anchorsClick(id){
				// eslint-disable-next-line
				$('html, body').animate({
					// eslint-disable-next-line
					scrollTop: $('#'+id).offset().top - document.querySelector('.site-header').getBoundingClientRect().height + 2
				}, 0);
			},
			goToRegister(){
				if(!this.getUserStatus){
					this.$router.push({name: 'Register'})
				}
			}
		}
	}
</script>
<style lang="scss">
	.agile_home-page{
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;

		.slide{
			min-height: calc(100vh - 60px);
			background-size: cover;
			background-position: center;

			@media (min-width: 1040px){
				min-height: calc(100vh - 71px);
			}
			@media (max-width: 1039px) {
				min-height: 54vw;
			}
		}
	}

	.home{

		&__floating-dots{
			text-align: right;
			position: fixed;
			right: 0;
			top: 160px;
			padding: 15px;
			background-color: rgba(0,0,0,0.5);
			z-index: 2222;
			display: flex;
			flex-flow: column nowrap;
			align-items: center;
			justify-content: flex-end;
			color: #000;
			color: #fff;

			@media (max-width: 1130px) {
				display: none;
			}

			&.white{
				//color: white;
			}

			&__item{

				cursor: pointer;
				display: block;
				text-decoration: none!important;



				$float-background-color: #a0a0a0;
				$float-border-color: #fff;
				&:after {
					content: '';
					width: 10px;
					height: 10px;
					border-radius: 50%;

					margin-left: 10px;
					display: inline-block;

					background-color: $float-background-color;
					border: 2px solid $float-border-color;

				}

				&.active {
					font-weight: bold;
					&:after {
						border-color: $float-background-color;
					}
				}
			}


		}
	}
</style>
